/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import PageBox from "../../layouts/pageBox";
import {useTranslation} from "react-i18next";
import {Navigate} from "react-router-dom";

const Imprint = () => {

    return <Navigate to="/" replace />;

    const { t, i18n } = useTranslation();

    const data = {
        title: t('imprint.title'),
        subtitle: ''
    };

    return (
        <PageBox data={data} showAdds={false}>
            <div className='page-body'>
                <div dangerouslySetInnerHTML={{__html: t('imprint.content' ) }} />
            </div>
        </PageBox>
    );
};

export default Imprint;
